export interface SurveysRouter {
  goToDetail(id: string): void;
  goToList(query?: string): void;
  goToAnalytics(id: string): void;
  goToSurveyUserAnswers(surveyId: string, attemptId: string): void;
  goBack(prevState: { pathname: string; search: string }): void;
  goToPassing(surveyId: string, attemptId: string, sectionIndex: number): void;
  goToCompleted(id: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveysRouter = Symbol('SurveysRouter');
